import { SET_CUSTOMER_COMPANY_ACTIVITY } from '../actions';

const customercompanyactivity = (state = [], action) => {
  switch (action.type) {
    case SET_CUSTOMER_COMPANY_ACTIVITY:
      return [...action.value];
    default: return state;
  }
}

export default customercompanyactivity;
